<template>
  <div class="d-flex flex-column min-vh-100" v-bind="$attrs">
    <PwaInstallBanner />
    <div v-if="userStore.isImpersonated" class="position-md-fixed top-0 start-0 bg-warning fw-bold small px-4 pt-1 pb-2 ms-2 rounded-bottom shadow z-3">Connecté en tant que {{ `${userStore.currentUser?.firstName} ${userStore.currentUser?.lastName?.toUpperCase()}` }} <i class="fa fa-close ps-2" role="button" @click="userStore.stopImpersonation"></i></div>

    <TopBannerComponent
      :banners="bannerStore.banners"
    />

    <HeaderComponent :class="headerClass" :logo="logo" />

    <div :class="`${containerClass} ${clearContainerClasses ? '' : 'flex-grow-1 container-lg'}`">
      <slot v-if="!loading"></slot>
      <div v-else class="text-center mt-5">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Chargement en cours...</span>
        </div>
        <div>Chargement en cours...</div>
      </div>
    </div>

    <FooterComponent />
  </div>
</template>

<script setup lang="ts">
import FooterComponent from '@/components/FooterComponent.vue'
import HeaderComponent from '@/components/HeaderComponent.vue'
import { useUserStore } from '@/stores/userStore'
import { useBannerStore } from '@/stores/bannerStore'
import TopBannerComponent from '@/components/page/TopBannerComponent.vue'
const userStore = useUserStore()
const bannerStore = useBannerStore()

withDefaults(defineProps<{
  loading?: boolean,
  headerClass?: string,
  containerClass?: string,
  clearContainerClasses?: boolean,
  logo?: string
}>(), {
  loading: false,
  headerClass: '',
  containerClass: '',
  clearContainerClasses: false,
  logo: undefined
})
</script>
